/**
 * Meta Pixel (Facebook Pixel) conversion event helpers.
 * Pixel ID 168174724615163 is initialized in /public/index.html with a PageView track.
 * Helpers below fire conversion events at the right funnel moments so Meta Ads
 * Manager can optimize toward actual leads (not just clicks).
 */

const isReady = () => typeof window !== "undefined" && typeof window.fbq === "function";

/** Wrapper that silently no-ops if the pixel hasn't loaded (e.g., ad blocker). */
function track(eventName, params = {}, custom = false) {
  if (!isReady()) return;
  try {
    if (custom) {
      window.fbq("trackCustom", eventName, params);
    } else {
      window.fbq("track", eventName, params);
    }
  } catch (e) {
    // Don't let pixel errors break the app
    console.warn("[pixel]", e);
  }
}

// ---- Standard events (Meta recognizes these for ad optimization) ----

/** Fires when a user clicks the primary "Analyze My Bill" CTA on the landing page. */
export const trackInitiateCheckout = () =>
  track("InitiateCheckout", { content_category: "bill_analysis" });

/** Fires when the AI vision successfully parses an uploaded bill. */
export const trackAddToCart = (billData = {}) =>
  track("AddToCart", {
    content_category: "bill_parsed",
    content_name: billData?.utility_provider || "unknown",
    value: billData?.monthly_bill || 0,
    currency: "USD",
  });

/**
 * THE BIG ONE — fires when a lead form is submitted and accepted by GHL.
 * Facebook will use this to optimize ads toward users likely to convert.
 */
export const trackLead = (leadData = {}) => {
  const value = leadData?.estimated_25yr_savings || leadData?.estimated_system_cost || 0;
  track("Lead", {
    content_category: "solar_lead",
    content_name: leadData?.interest_type || "solar",
    value: value,
    currency: "USD",
    residency_type: leadData?.residency_type || "owner",
    island: leadData?.island || null,
  });
};

// ---- Custom events for funnel analytics ----

/** Fires when a user completes the wizard (lands on Thank You screen). */
export const trackWizardComplete = () => track("WizardComplete", {}, true);

/** Fires when a user picks an EcoFlow product on the backup-environment selector. */
export const trackEcoFlowInterest = (product = {}) =>
  track("EcoFlowInterest", {
    product_id: product?.id,
    product_name: product?.name,
    tier: product?.tier,
    price: product?.price_usd,
  }, true);

/** Fires when the backend flags the user as a hot Time-of-Use shift candidate. */
export const trackHotTOUCandidate = () => track("HotTOUCandidate", {}, true);
